<app-modal-container [displayFooter]="false">
  <span class="modal-header-content">{{ modalInputData.data.alt }}</span>

  <span class="modal-body-content">
    <img [src]="modalInputData.data.imageSrc" [alt]="modalInputData.data.alt" [style.filter]="filter" />
  </span>
</app-modal-container>
